<template>
  <div class="col-lg-12">
    <clip-loader v-if="loading" />
    <div v-else class="col-md-12">
      <CdrFlagBanner
        v-for="(flag, index) in mainExamFlags"
        :key="'flag-' + index"
        v-bind="flag"
      />
      <div v-for="(examination, key) in examinationCollection" :key="key">
        <patient-examination
          :examination="examination"
          :product="productDefinition"
          :view-option="
            key === 0
              ? 'patient_examination'
              : 'patient_examination_previous_case'
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import PatientExamination from "./PatientExamination.vue";
import CdrFlagBanner from "../../../ClinicalDataRemoval/CdrFlagBanner.vue";
import ClipLoader from "../../../Utils/ClipLoader.vue";
export default {
  components: {
    ClipLoader,
    CdrFlagBanner,
    PatientExamination,
  },
  props: {
    loading: { type: Boolean, default: true },
    examinationCollection: Object,
    productDefinition: Object,
  },
  computed: {
    mainExamFlags() {
      if (!this.examinationCollection) return [];
      const lastItem =
        this.examinationCollection[this.examinationCollection.length - 1];
      return lastItem?.pendingCdrFlags ?? [];
    },
  },
};
</script>
